// src/components/practice/tasks/MatchingHeadingsToTexts.jsx
import React, { useState } from 'react';
// renderExample is no longer needed
import { FlagButton } from '../PartDisplay';

const MatchingHeadingsToTexts = ({
  partData,
  questions,
  examples,
  partAnswers,
  handleSingleAnswer,
  flaggedQuestions,
  toggleFlagQuestion,
  isMobileAnswerSheetOpen,
  onCloseMobileAnswerSheet,
  ...props
}) => {
  const allProps = { flaggedQuestions, toggleFlagQuestion, ...props };
  const headings = partData.content.headings || [];
  const texts = partData.content.texts || [];

  // Map questionNumbers to questionIds
  const questionMap = questions.reduce((acc, q) => {
      acc[q.questionNumber] = q.questionId;
      return acc;
  }, {});

  // --- MODIFICATION ---
  // Get a list of used heading IDs, including from examples
  const realAnswers = Object.values(partAnswers).filter(Boolean);
  const exampleAnswers = examples.map(ex => ex.correctAnswer);
  const usedHeadings = [...realAnswers, ...exampleAnswers];
  // --- END MODIFICATION ---

  const isHeadingUsed = (headingId) => usedHeadings.includes(headingId);

  // State to manage which question box is open
  const [selectedQuestionId, setSelectedQuestionId] = useState(null);

  // Click handler for selecting a question (Unchanged)
  const handleQuestionSelect = (questionId) => {
    setSelectedQuestionId(prevId => (prevId === questionId ? null : questionId));
  };

  // Click handler for selecting an option (Unchanged)
  const handleOptionSelect = (questionId, optionId) => {
    const otherQuestionId = Object.keys(partAnswers).find(
      (qid) => qid !== questionId && partAnswers[qid] === optionId
    );
    if (otherQuestionId) {
      handleSingleAnswer(otherQuestionId, null);
    }
    if (partAnswers[questionId] === optionId) {
      handleSingleAnswer(questionId, null);
    } else {
      handleSingleAnswer(questionId, optionId);
    }
    setSelectedQuestionId(null);
  };


  return (
    <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">



      {/* --- Examples (Global, at the top) REMOVED --- */}

      {/* Headings Display (Answer Bank) */}
      <div className="border-2 border-gray-900 bg-white p-6 rounded-none mb-8">
        <h3 className="text-xl font-bold text-gray-900 border-b-2 border-gray-300 pb-3 mb-4">
          Überschriften
        </h3>
        <ul className="list-none space-y-2 md:columns-2">
          {headings.map(h => {
            // This 'isUsed' check now includes example answers
            const isUsed = isHeadingUsed(h.id);
            return (
              <li key={h.id} className="mb-1 pr-2 break-inside-avoid">
                <span className="font-bold text-gray-900 mr-2">{h.id.toUpperCase()})</span>
                <span className={`
                  transition-all
                  ${isUsed ? 'text-gray-400 line-through' : 'text-gray-700'}
                `}>
                  {h.text}
                </span>
              </li>
            );
          })}
        </ul>
      </div>

      {/* Main content area: Map over texts and create a new row for each */}
      <div className="space-y-6">

        {/* --- NEW: Map over examples first --- */}
        {examples.map(ex => {
          const textItem = texts.find(t => t.id == ex.questionNumber);
          if (!textItem) return null; // Skip if no matching text

          const correctHeading = headings.find(h => h.id === ex.correctAnswer);
          const correctHeadingText = correctHeading ? correctHeading.id.toUpperCase() : '?';

          return (
            <div key={`ex-${ex.questionNumber}`} className="grid grid-cols-1 md:grid-cols-5 md:gap-8">
              {/* --- LEFT COLUMN (Example Text Paragraph) --- */}
              <div className="md:col-span-3">
                <div className="border-2 border-gray-900 bg-yellow-50 p-6 rounded-none h-full opacity-90">
                  <h5 className="font-bold text-lg mb-2 text-gray-900">Text {textItem.id.toUpperCase()} (Beispiel)</h5>
                  <p className="prose prose-sm max-w-none text-gray-900 leading-relaxed whitespace-pre-wrap">
                    {textItem.text}
                  </p>
                </div>
              </div>

              {/* --- RIGHT COLUMN (Example Answer Box) --- */}
              <div className="md:col-span-2 mt-4 md:mt-0">
                <div
                  className="bg-yellow-50 rounded-none border-2 border-gray-900 p-4 h-full opacity-90"
                >
                  {/* Simplified Info Bar for Example */}
                  <div className="flex items-center justify-between h-full">
                    <div className="flex items-start flex-1">
                      {/* No Flag */}
                      <p className="font-semibold ml-2 text-gray-900">
                        <span className="font-bold mr-2 text-gray-600">
                          {textItem.id.toUpperCase()}.
                        </span>
                        Welche Überschrift passt?
                      </p>
                    </div>
                    {/* Black Answer Box */}
                    <div className="ml-4 flex-shrink-0">
                      <div
                        className="border-2 border-gray-900 bg-gray-900 text-white font-bold text-sm px-3 py-1.5 rounded-none cursor-not-allowed"
                        style={{ minWidth: '70px', textAlign: 'center' }}
                      >
                        {correctHeadingText}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        })}

        {/* --- Regular Questions --- */}
        {texts.map(textItem => {
          const questionId = questionMap[textItem.id];
          if (!questionId) return null; // Skip example texts

          const currentAnswer = partAnswers[questionId];
          const selectedOption = headings.find(h => h.id === currentAnswer);
          const isSelected = selectedQuestionId === questionId;

          return (
            <div key={textItem.id} className="grid grid-cols-1 md:grid-cols-5 md:gap-8">
              {/* --- LEFT COLUMN (Text Paragraph) --- */}
              <div className="md:col-span-3 min-w-0">
                <div className="border-2 border-gray-900 bg-white p-6 rounded-none h-full">
                  <h5 className="font-bold text-lg mb-2 text-gray-900">Text {textItem.id.toUpperCase()}</h5>
                  <p className="prose prose-sm max-w-none text-gray-900 leading-relaxed whitespace-pre-wrap">
                    {textItem.text}
                  </p>
                </div>
              </div>

              {/* --- RIGHT COLUMN (Answer Box) --- */}
              <div className="md:col-span-2 mt-4 md:mt-0">
                <div
                  className={`
                    bg-white rounded-none border-2 transition-all duration-200
                    ${isSelected
                      ? 'border-gray-900 shadow-lg'
                      : currentAnswer
                        ? 'border-gray-900 bg-gray-50'
                        : 'border-gray-400 hover:border-gray-900'
                    }
                  `}
                >
                  {/* Clickable Info Bar (Unchanged) */}
                  <div
                    onClick={() => handleQuestionSelect(questionId)}
                    className={`
                      p-4 flex items-center justify-between min-h-[72px] cursor-pointer transition-all
                      ${isSelected 
                        ? 'bg-gray-900 text-white' 
                        : currentAnswer 
                          ? '' 
                          : 'hover:bg-gray-50 hover:shadow-md hover:-translatey-0.5'
                      }
                    `}
                  >
                    <div className="flex items-start flex-1">
                      <FlagButton {...allProps} questionId={questionId} className={isSelected ? 'flag-light' : ''} />
                      <p className={`font-semibold ml-2 ${isSelected ? 'text-white' : 'text-gray-900'}`}>
                        <span className={`font-bold mr-2 ${isSelected ? 'text-gray-300' : 'text-gray-500'}`}>
                          {textItem.id.toUpperCase()}.
                        </span>
                        Welche Überschrift passt?
                      </p>
                    </div>
                    <div className="text-right ml-4">
                      {selectedOption ? (
                        <span className="font-bold text-2xl text-blue-700">{selectedOption.id.toUpperCase()}</span>
                      ) : isSelected ? (
                        <div className="w-10 h-10 bg-white rounded-md flex items-center justify-center">
                          <span className="text-gray-900 font-bold text-xl">?</span>
                        </div>
                      ) : (
                        <div className="w-10 h-10 bg-gray-200 rounded-md"></div>
                      )}
                    </div>
                  </div>

                  {/* Inline Options (appears on click) */}
                  {isSelected && (
                    <div className="p-4 border-t-2 border-gray-900 bg-gray-50">
                      <p className="text-xs font-semibold uppercase tracking-wide text-gray-700 mb-3">
                        Überschrift wählen:
                      </p>
                      <div className="space-y-2">
                        {headings.map(heading => {
                          const questionUsingThisOption = Object.keys(partAnswers).find(
                            (qid) => partAnswers[qid] === heading.id
                          );
                          const isUsedByAnotherQuestion =
                            questionUsingThisOption &&
                            questionUsingThisOption !== selectedQuestionId;

                          // --- MODIFICATION ---
                          // Check if used by an example
                          const isUsedByExample = exampleAnswers.includes(heading.id);
                          const isDisabled = isUsedByAnotherQuestion || isUsedByExample;
                          // --- END MODIFICATION ---

                          return (
                            <button
                              key={heading.id}
                              onClick={() => handleOptionSelect(questionId, heading.id)}
                              disabled={isDisabled} // Add disabled attribute
                              className={`
                                w-full text-left p-3 rounded-none border-2 flex items-center justify-between transition-all
                                ${isDisabled
                                  ? 'bg-gray-100 border-gray-300 text-gray-400 line-through cursor-not-allowed' // Disabled style
                                  : 'bg-white border-gray-400 text-gray-900 hover:border-gray-900 hover:shadow-md hover:-translate-y-0.5'
                                }
                              `}
                            >
                              <span className="font-bold w-6 flex-shrink-0">{heading.id.toUpperCase()})</span>
                              <span className="flex-1 text-sm">{heading.text}</span>
                            </button>
                          );
                        })}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default MatchingHeadingsToTexts;